var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerwhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0596 4.34033C10.686 4.34033 7.93457 7.06762 7.93457 10.4115C7.93457 12.5019 9.01123 14.3585 10.6416 15.4528C7.521 16.7808 5.30957 19.8503 5.30957 23.4212H7.05957C7.05957 19.5793 10.1836 16.4827 14.0596 16.4827C17.9355 16.4827 21.0596 19.5793 21.0596 23.4212H22.8096C22.8096 19.8503 20.5981 16.7808 17.4775 15.4528C19.1079 14.3585 20.1846 12.5019 20.1846 10.4115C20.1846 7.06762 17.4331 4.34033 14.0596 4.34033ZM14.0596 6.07496C16.4863 6.07496 18.4346 8.00608 18.4346 10.4115C18.4346 12.817 16.4863 14.7481 14.0596 14.7481C11.6328 14.7481 9.68457 12.817 9.68457 10.4115C9.68457 8.00608 11.6328 6.07496 14.0596 6.07496Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerwhite);
export default __webpack_public_path__ + "static/media/customerwhite.186439dfd59bd6d56a0fa4c6031259eb.svg";
export { ForwardRef as ReactComponent };